import {Component, output} from '@angular/core';
import {TaListBase} from '../../../pages/ta-list-base.directive';
import {BasicTaDetails, UserService} from '../../../../api';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {Button} from 'primeng/button';
import {DatePipe, NgClass} from '@angular/common';
import {canCreateTemplateFrom, toTAStatusText} from '../../../../util/app.types';
import {Chip} from 'primeng/chip';
import {LocationService} from '../../../../services/location.service';
import {InputText} from 'primeng/inputtext';
import {ScrollHeightDirective} from '../../../directives/scroll-height.directive';
import {PrepaidIndicatorComponent} from '../../prepaid-indicator/prepaid-indicator.component';
import {AttachmentIndicatorComponent} from '../../attachment-indicator/attachment-indicator.component';
import {TaCommentCount} from '../../ta-comments/ta-comment-count';

@Component({
  selector: 'my-submissions-list',
  imports: [
    TaCommentCount,
    FormsModule,
    TableModule,
    Button,
    NgClass,
    DatePipe,
    Chip,
    InputText,
    ScrollHeightDirective,
    PrepaidIndicatorComponent,
    AttachmentIndicatorComponent,
  ],
  templateUrl: './my-submissions-list.component.html',
  styleUrl: './my-submissions-list.component.scss'
})
export class MySubmissionsListComponent extends TaListBase {
  createTemplate = output<BasicTaDetails>();

  constructor(
    private userApi: UserService,
    protected locationService: LocationService,
  ) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loadTaList();
  }

  reloadTaList(): void {
    this.store.resetTaState();
    this.loadTaList()
  }

  loadTaList(): void {
    this.loadingService.showLoading({message: 'Loading data', targetElement: this.loadingRef});
    this.userApi.getUserActiveSubmissions().subscribe({
      next: result => {
        if (result.data) {
          this.availableTaList.set(result.data.sort((a, b) => {
            const da = a.created?.created ? new Date(a.created.created).getTime() : 0;
            const db = b.created?.created ? new Date(b.created.created).getTime() : 0;

            return db - da; // newest first
          }));
        } else {
          console.error('No user active TA list found.');
        }
        this.loadingService.hideLoading();
      },
      error: err => {
        console.error(err);
        this.loadingService.hideLoading();
      }
    });
  }

  protected readonly toTAStatusText = toTAStatusText;
  protected readonly canCreateTemplateFrom = canCreateTemplateFrom;
}
